
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';

import '../scss/global.scss';
import '../scss/header.scss';
import '../scss/product-detail.scss';

window.addEventListener('load', () => {
  const $ = window.$;
  $('.banner').addClass('animated');

  const swiper1 = new Swiper('.swiper-1', {
    loop: true, // 循环模式选项
    on: {
      slideChange() {
        let index = this.activeIndex - 1;
        console.log(this.activeIndex);
        if (index < 0) {
          index = $('.swiper-2 .swiper-slide').length - 1;
        }
        if (index > $('.swiper-2 .swiper-slide').length - 1) {
          index = 0;
        }
        $('.swiper-2 .swiper-slide').find('img').removeClass('active');
        $('.swiper-2 .swiper-slide')
          .eq(index).find('img')
          .addClass('active');
      },
    },

  });

  let swiper2Direction = 'vertical';
  if (window.innerWidth < 992) {
    swiper2Direction = 'horizontal';
  }

  const swiper2 = new Swiper('.swiper-2', {
    direction: swiper2Direction,
    slidesPerView: 4,
    spaceBetween: 10,
    freeMode: true,

  });

  $('.swiper-2 .swiper-slide').on('click', function () {
    swiper1.slideTo($(this).index() + 1);
  });

  window.addEventListener('resize', () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 992 && swiper2Direction === 'vertical') {
      swiper2Direction = 'horizontal';
      swiper2.changeDirection(swiper2Direction);
    } else if (windowWidth >= 992 && swiper2Direction === 'horizontal') {
      swiper2Direction = 'vertical';
      swiper2.changeDirection(swiper2Direction);
    }
  });
});

